import { generatePDF } from "@/utils/generatePDF";

import { EXPORTABLES_PREVIEW_FORM_ID } from "@/components/AIComponents/ExportablesModal/ExportablesModal.constants";
import type { TemplateDefinition } from "@/components/AIComponents/ExportablesModal/templates/registry";
import type { ExportablesDataTypes } from "@/types/models/Exportables.interface";

export function getDownloadHandler({
  selectedExportable,
}: {
  selectedExportable: TemplateDefinition<ExportablesDataTypes>;
}) {
  return async () => {
    try {
      const label = selectedExportable.label || selectedExportable.title;
      const filename = `${label}.pdf`;

      const pdfBlob = await generatePDF(
        document.querySelector(`#${EXPORTABLES_PREVIEW_FORM_ID}`)!,
        {
          filename,
          format: "letter",
          orientation: selectedExportable.pdfOptions.orientation,
        },
      );

      // Create a URL for the blob and trigger download
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };
}
